import { forwardRef } from 'react'
import { Textarea, TextareaProps } from '@chakra-ui/react'
import { FormControl } from 'components'

type Props = TextareaProps & {
  label?: string
  helperText?: string
}

export const TextArea = forwardRef<HTMLInputElement, Props>(
  ({ label, helperText, variant = 'outline', size = 'md', ...props }, ref) => {
    return (
      <FormControl label={label} helperText={helperText}>
        <Textarea ref={ref} variant={variant} size={size} {...props} />
      </FormControl>
    )
  },
)

TextArea.displayName = 'TextArea'
